"use client";

import { useMutation } from "@tanstack/react-query";
import type { RequestPasswordResetRequest } from "cmw-client";
import { browserCmw } from "@/lib/ky/browser";

export type RequestPasswordResetInput = RequestPasswordResetRequest;

export const useRequestPasswordReset = () =>
  useMutation({
    mutationFn: (body: RequestPasswordResetInput) =>
      browserCmw.auth.requestPasswordReset(body),
  });
